import { useTranslation } from "react-i18next"
import { Banner } from "@/components/ui/banner"
import { useWaitingRoomFilters } from "@/modules/waiting-room/contexts/waiting-room-filters-context"

const AppointmentWarning = () => {
  const { filters } = useWaitingRoomFilters()
  const { t } = useTranslation()
  const isLiveUpdateAvailable = !filters.dateRange

  return (
    !isLiveUpdateAvailable && (
      <div className="px-8">
        <Banner type="inline" variant="warning" data-testid="live-update-unavailable-banner">
          {t("scheduling.waitingRoom.liveUpdateUnavailable")}
        </Banner>
      </div>
    )
  )
}
export { AppointmentWarning }
